var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaisedHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.797,
    height: 13.667,
    viewBox: "0 0 11.797 13.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493",
    transform: "translate(-645.968 -549.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M2498.884,238.454v-3.906a.653.653,0,1,0-1.3,0v3.464h-1.076V232.55a.653.653,0,1,0-1.3,0v5.462h-1.076v-6.046a.653.653,0,1,0-1.3,0v6.046h-1.076v-4.6a.653.653,0,1,0-1.3,0v5.053c0,.007,0,.013,0,.02V240.7a4.943,4.943,0,0,0-2.534-1.066.839.839,0,0,0-.836.847.872.872,0,0,0,.749.951,3.951,3.951,0,0,1,2.94,2.234.846.846,0,0,0,.052.075,2.226,2.226,0,0,0,1.9,1.16h3.873a2.432,2.432,0,0,0,2.276-2.559v-3.863C2498.888,238.473,2498.884,238.465,2498.884,238.454Z",
    transform: "translate(-1841.124 318.263)",
    fill: "#fcaf00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisedHand);
export default __webpack_public_path__ + "static/media/raisedHand.f46ab83b3e5889a046629b85447eed63.svg";
export { ForwardRef as ReactComponent };